export class SupernovaException extends Error {
    static wrongFormat(message) {
        return new SupernovaException("WrongFormat", message);
    }
    static validationError(message) {
        return new SupernovaException("ValidationError", message);
    }
    static accessDenied(message) {
        return new SupernovaException("AccessDenied", message);
    }
    static tooMuchWork(message) {
        return new SupernovaException("TooMuchWork", message);
    }
    static notFound(message) {
        return new SupernovaException("ResourceNotFound", message);
    }
    static timeout(message) {
        return new SupernovaException("Timeout", message);
    }
    static conflict(message) {
        return new SupernovaException("Conflict", message);
    }
    static notImplemented(message) {
        return new SupernovaException("NotImplemented", message);
    }
    static wrongActionOrder(message) {
        return new SupernovaException("WrongActionOrder", message);
    }
    static invalidOperation(message) {
        return new SupernovaException("InvalidOperation", message);
    }
    static shouldNotHappen(message) {
        return new SupernovaException("UnexpectedError", message);
    }
    static ipRestricted(message) {
        return new SupernovaException("IPRestricted", message);
    }
    static planRestricted(message) {
        return new SupernovaException("PlanRestricted", message);
    }
    static missingWorkspacePermission(message) {
        return new SupernovaException("MissingWorkspacePermission", message);
    }
    static missingExporterPermission(message) {
        return new SupernovaException("MissingExporterPermission", message);
    }
    static missingIntegration(message) {
        return new SupernovaException("MissingIntegration", message);
    }
    static missingIntegrationAccess(message) {
        return new SupernovaException("MissingIntegrationAccess", message);
    }
    static noAccess(message) {
        return new SupernovaException("NoAccess", message);
    }
    static missingCredentials(message) {
        return new SupernovaException("MissingCredentials", message);
    }
    static thirdPartyError(message) {
        return new SupernovaException("ThirdPartyError", message);
    }
    static userDeactivated(message) {
        return new SupernovaException("UserDeactivated", message);
    }
    //
    // To refactor
    //
    static badRequest(message) {
        return new SupernovaException("BadRequest", message);
    }
    //
    // Properties
    //
    constructor(type, message) {
        const fullMessage = message || `${type}: something went wrong`;
        super(fullMessage);
        this.type = type;
    }
}
export function errorToString(error) {
    var _a, _b, _c, _d, _e, _f;
    if (error instanceof Error) {
        const errorAny = error;
        const stderr = ((_c = (_b = (_a = errorAny.result) === null || _a === void 0 ? void 0 : _a.stderr) !== null && _b !== void 0 ? _b : errorAny.stderr) !== null && _c !== void 0 ? _c : "").trim();
        const stdout = ((_f = (_e = (_d = errorAny.result) === null || _d === void 0 ? void 0 : _d.stdout) !== null && _e !== void 0 ? _e : errorAny.stdout) !== null && _f !== void 0 ? _f : "").trim();
        const output = [stderr, stdout].filter(Boolean).join("\n");
        return output ? `${error.message}\n${output}` : error.message;
    }
    return String(error);
}
